
import Backbone from 'backbone'
import Cocktail from 'backbone.cocktail'
import FacadeMixin from './mixins/FacadeMixin'
import MapModelMixin from './mixins/MapModelMixin'
import TagsMixin from './mixins/TagsMixin'
import Unit from '../facades/Unit'

class UnitModel extends Backbone.Model {

  initialize(attributes, options = {}) {
    this._facade = new Unit(this)

    if (attributes.shape) {
      this.set('fill', attributes.shape.fill)
    }
  }

  color(value) {
    this.set('fill', value)
    return this
  }

  data() {
    return this.toJSON()
  }
}

Cocktail.mixin(UnitModel, MapModelMixin, FacadeMixin, TagsMixin)

export default UnitModel
